import { toast } from "react-toastify";
import { IWM } from "../config/urlConfig";

// Generate the activity report for a date range and email it to the current
// user. Returns a promise resolving to true/false so callers can manage a
// loading state. The report is delivered to the requesting user's email only.
export const sendReport = (startDate, endDate) => () => {
  return IWM.post("/analytics/report", { startDate, endDate })
    .then((res) => {
      toast.success(
        res?.data?.message ||
          "Report is being generated and will be emailed to you shortly."
      );
      return true;
    })
    .catch((ex) => {
      toast.error(
        ex?.response?.data?.message ||
          ex?.response?.data ||
          "Could not generate the report. Please try again."
      );
      return false;
    });
};

export const getHistoryWithANetwork = (id) => (dispatch) => {
  dispatch({ type: "GETTING_PICKUP_HISTORY_WITH_A_NETWORK" });
  IWM.get("/pickups/read/organization/history/" + id)
    .then((res) => {
      dispatch({
        type: "GOT_PICKUP_HISTORY_WITH_A_NETWORK",
        payload: res.data,
      });
    })
    .catch((ex) => {
      dispatch({ type: "CANNOT_GET_PICKUP_HISTORY_WITH_A_NETWORK" });
    });
};

export const getAnalyticsOverview = () => (dispatch) => {
  dispatch({ type: "GETTING_OVERVIEW" });
  IWM.get("/analytics/read/overview")
    .then((res) => {
      dispatch({ type: "GOT_OVERVIEW", payload: res.data });
    })
    .catch((ex) => {
      dispatch({ type: "CANNOT_GET_OVERVIEW" });
    });
};

export const getNetworkAnalytics = () => (dispatch) => {
  dispatch({ type: "GETTING_NETWORK_ANALYTICS" });
  IWM.get("/analytics/read/network-analytics")
    .then((res) => {
      console.log(res.data);
      dispatch({ type: "GOT_NETWORK_ANALYTICS", payload: res.data });
    })
    .catch((ex) => {
      dispatch({ type: "CANNOT_GET_NETWORK_ANALYTICS" });
    });
};

export const getMonthlyQuantityOverTime = (months) => (dispatch) => {
  dispatch({ type: "GETTING_MONTHLY_QUANTITY_OVER_TIME" });

  IWM.get(
    "/analytics/read/monthly-quantity-over-time" +
    (months ? "?months=" + months : "")
  )
    .then((res) => {
      dispatch({
        type: "GOT_MONTHLY_QUANTITY_OVER_TIME",
        payload: res.data,
      });
    })
    .catch((ex) => {
      dispatch({ type: "CANNOT_GET_MONTHLY_QUANTITY_OVER_TIME" });
    });
};

export const getMaterialIntakeChart = (months) => (dispatch) => {
  dispatch({ type: "GETTING_MONTHLY_QUANTITY_OVER_TIME" });

  IWM.get(
    "/analytics/read/monthly-quantity-over-time" +
    (months ? "?months=" + months : "")
  )
    .then((res) => {
      dispatch({
        type: "GOT_MONTHLY_QUANTITY_OVER_TIME",
        payload: res.data,
      });
    })
    .catch((ex) => {
      dispatch({ type: "CANNOT_GET_MONTHLY_QUANTITY_OVER_TIME" });
    });
};

export const getQuantityOverTime = (start, end) => (dispatch) => {
  dispatch({ type: "GETTING_QUANTITY_OVER_TIME" });

  IWM.get(
    "/analytics/read/quantity-over-time" +
    (start ? "?start=" + start : "") +
    (end ? "&end=" + end : "")
  )
    .then((res) => {
      dispatch({
        type: "GOT_QUANTITY_OVER_TIME",
        payload: res.data,
      });
    })
    .catch((ex) => {
      dispatch({ type: "CANNOT_GET_QUANTITY_OVER_TIME" });
    });
};

export const getReports = () => (dispatch) => {
  dispatch({ type: "GETTING_REPORTS" });

  IWM.get("/analytics/read/reports")
    .then((res) => {
      dispatch({
        type: "GOT_REPORTS",
        payload: res.data,
      });
    })
    .catch((ex) => {
      dispatch({ type: "CANNOT_GET_REPORTS" });
    });
};

export const getBestPerformers = (start, end) => (dispatch) => {
  dispatch({ type: "GETTING_BEST_PERFORMERS" });

  let url = "/analytics/read/best-performers";
  const params = [];
  if (start) params.push("start=" + start);
  if (end) params.push("end=" + end);
  if (params.length > 0) {
    url += "?" + params.join("&");
  }

  IWM.get(url)
    .then((res) => {
      dispatch({
        type: "GOT_BEST_PERFORMERS",
        payload: res.data,
      });
    })
    .catch((ex) => {
      dispatch({ type: "CANNOT_GET_BEST_PERFORMERS" });
    });
};